import loginFox from "../assets/onboarding/login-fox.svg";
import onboardingFox from "../assets/onboarding/onboarding-fox.svg";
import wordmark from "../assets/onboarding/wordmark.svg";
import check from "../assets/onboarding/check.svg";
import message from "../assets/onboarding/message.svg";
import { brand, hostTenant } from "../branding/generated/brand-manifest";

// The login / onboarding funnel is locked to Zenvoya (assets + the `brand-zenvoya`
// scope class) regardless of REACT_APP_TENANT — EXCEPT on a domain tenant
// (brand.json "hosts", e.g. indigo.localhost), where it follows that tenant.
const _pub = (p: string) => (process.env.PUBLIC_URL || "") + p;

export const funnelBrandClass = hostTenant ? "" : "brand-zenvoya";

export const funnelLoginFox = hostTenant ? _pub(brand.images.assistantMark) : loginFox;
export const funnelOnboardingFox = hostTenant ? _pub(brand.images.assistantMark) : onboardingFox;
export const funnelWordmark = hostTenant ? _pub(brand.logo.wordmark) : wordmark;
export const funnelCheck = hostTenant ? _pub(`${brand.iconsDir}/check.svg`) : check;
export const funnelMessage = hostTenant ? _pub(`${brand.iconsDir}/message.svg`) : message;
